var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapabilitiesIconItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1464 12.7689C13.6251 11.9926 14.6455 10.4399 14.6455 8.65064C14.6455 6.08503 12.5604 4 9.99481 4C7.4292 4 5.35156 6.08503 5.35156 8.65064C5.35156 10.4399 6.37189 12 7.85064 12.7689",
    stroke: "#DA773D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5154 14.4023V14.565C11.471 15.3709 10.8056 15.9994 9.99227 15.9994C9.17896 15.9994 8.51353 15.3709 8.47656 14.565V14.4023",
    stroke: "#DA773D",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9399 12.4355H8.05077C7.93644 12.4355 7.84375 12.5282 7.84375 12.6426V14.1952C7.84375 14.3096 7.93644 14.4023 8.05077 14.4023H11.9399C12.0542 14.4023 12.1469 14.3096 12.1469 14.1952V12.6426C12.1469 12.5282 12.0542 12.4355 11.9399 12.4355Z",
    stroke: "#DA773D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapabilitiesIconItem);
export default __webpack_public_path__ + "static/media/capabilities-icon-item.ec62777b2e90aee7df37e7201971930d.svg";
export { ForwardRef as ReactComponent };